import { Component } from '@angular/core';import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-mutuelle-sante-internationale',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './assurance-mutuelle-sante-internationale.component.html',
  styleUrls: ['./assurance-mutuelle-sante-internationale.component.scss']
})
export class AssuranceMutuelleSanteInternationaleComponent {
  title = 'Assurance Mutuelle Santé Internationale';
  subtitle = '';
  heroImage = 'assets/static_pages_images/the-cardiologist-henri-vaquez.jpg';
  
  breadcrumbs = [
    { label: 'Particuliers', link: undefined },
    { label: 'Assurance Mutuelle Santé Internationale', link: undefined }
  ];

  prevPage = { title: 'Mutuelle Santé',
    link: '/assurance-sante-particuliers'
  };

  nextPage = { title: 'Prévoyance GAV',
    link: '/assurance-prevoyance-gav'
  };

  partners = [
    { name: 'GENERALI', logo: 'assets/images/logos/generali-logo.png' },
    { name: 'APRIL', logo: 'assets/images/logos/april-logo.png' },
    { name: 'ALPTIS', logo: 'assets/logos/ALPTIS.PNG' },
    { name: 'SWISSLIFE', logo: 'assets/images/logos/swisslife-logo.png' },
    { name: 'MALAKOFF HUMANIS', logo: 'assets/logos/MALAKOFF.PNG' },
    { name: 'HENNER', logo: 'assets/logos/HENNER.PNG' },
    { name: 'CNAS SAVOIE', logo: 'assets/images/logos/cnas-savoie-logo.png' }
  ];

  constructor(private router: Router) {}

  navigateToComparison(): void {
    this.router.navigate(['/cac/comparaison']);
  }
}

